// credit goes to alrik :) --> https://cvpnet.visualstudio.com/CVPnet%20Anmeldung/_versionControl?path=%24/CVPnet%20Anmeldung/cvpnet-registration/src/plugins/i18n.js
import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context("../locales/Messages", true, /Messages_[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/Messages_([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function loadLocaleDateFormats() {
  const locales = require.context("../locales/DateFormats", true, /DateFormats_[A-Za-z0-9-_,\s]+\.json$/i);
  const dateTimeFormats = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/DateFormats_([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      dateTimeFormats[locale] = locales(key);
    }
  });
  return dateTimeFormats;
}

function loadLocaleNumberFormats() {
  const locales = require.context("../locales/NumberFormats", true, /NumberFormats_[A-Za-z0-9-_,\s]+\.json$/i);
  const numberFormats = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/NumberFormats_([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      numberFormats[locale] = locales(key);
    }
  });
  return numberFormats;
}

export default new VueI18n({
  locale: "de-DE",
  fallbackLocale: "de-DE",
  messages: loadLocaleMessages(),
  dateTimeFormats: loadLocaleDateFormats(),
  numberFormats: loadLocaleNumberFormats(),
});
